export const getPlaceholderInputError = (hasPlaceholderError: boolean, isUpdatingField: boolean) => {
    if (isUpdatingField && hasPlaceholderError) {
        return 'There is already an existing field with this placeholder text';
    }

    return hasPlaceholderError
        ? 'Change the placeholder text or select the existing field with this placeholder text below'
        : undefined;
};
